/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-group-1 ul');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('#modalAddToCartError .error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
}

$( document ).ready(function(){
  jQuery("#modalAddToCart").on("hidden.bs.modal", function () {
    var cprsli = $(this).find('.cart_product_slider');
    cprsli.hasClass('slick-initialized') && cprsli.slick('destroy');
    cprsli.empty();
  });
  jQuery('body').on('click', '.addtocart-js, .addtocart, .addtocartqv', function(e){
    var href = $(this).attr('href');
    if(href != '#addtocart' && !$(this).hasClass('addtocart') && !$(this).hasClass('addtocartqv')) return true;
    e.preventDefault();
    var id = $(this).data('prvariant');
    var obj_param = {};
    obj_param['qua'] = 1;
    obj_param['prid'] = $(this).attr('data-prid');
    obj_param['image'] = $(this).attr('data-image');
    obj_param['title'] = $(this).attr('data-title');
    obj_param['price'] = $(this).attr('data-price');
    
    console.log($(this))
    
    if(href == '#addtocart'){
      Shopify.addItem(id, obj_param);
    }
    else if($(this).hasClass('addtocartqv')){
      jQuery('#quickViewModal').modal('hide');
      Shopify.addItemFromFormStart('add-item-qv', obj_param);
    }
    else{
      Shopify.addItemFromFormStart('add-item-form', obj_param);
    }
  });
})

Shopify.addItem = function(variant_id, obj_param, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + obj_param['qua'] + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id, obj_param);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, obj_param,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      /*beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },*/
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          Shopify.cartPopapForm(obj_param);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
};

/* user functions */
Shopify.addItemFromFormStart = function(form, obj_param) {
  Shopify.addItemFromForm(form, obj_param);
}

Shopify.cartPopap = function(variant_id, obj_param={}) {
  addedProductPopup(jQuery('#modalAddToCart'), obj_param);
  jQuery('.currency .active').trigger('click');
  jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(obj_param) {
  addedProductPopup(jQuery('#modalAddToCart'), obj_param);
  jQuery('.currency .active').trigger('click');
  jQuery('#modalAddToCart').modal("toggle");
}
function addedProductPopup(_, obj_param){
  _.find('.cart_image').empty().html('<img src="'+obj_param['image']+'">');
  _.find('.cart_product_name').empty().html(obj_param['title']);
  _.find('.cart_product_price').empty().html(obj_param['price']);
  
  var items = jQuery('.prodslider'+obj_param['prid']);
  var cprb = _.find('.cart_product_slider_box');
  var cprsli = cprb.find('.cart_product_slider');
  
  if(items.length == 0){
    cprb.addClass('hide');
    return false;
  }

  cprsli.append(items.children().clone());
  cprb.removeClass('hide');

  setTimeout(function(){
    cprsli.slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    var h = cprsli.find('img').first().height();
    var d = cprsli.find('.slick-arrow').first().height();
    cprsli.find('.slick-arrow').css('top', parseInt((h-d)/2));
  }, 1000);
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
			
          if (value.length) {
            jQuery('.cart_message').hide();
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="cart__item"><div class="cart__item__image pull-left"><a href="' + item.url + '"><img src="' + item.image + '" alt=""/></a> </div><div class="cart__item__control"><div class="cart__item__delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" class="icon icon-delete"><span>'+jQuery(".cart_messages .delete").text()+'</span></a></div><div class="cart__item__edit"><a href="' + item.url + '" class="icon icon-edit"><span>'+jQuery(".cart_messages .edit").text()+'</span></a></div></div><div class="cart__item__info"><div class="cart__item__info__title"><h2><a href="' + item.url + '">' + item.title + '</a></h2></div><div class="cart__item__info__price"><span class="info-label">'+jQuery(".cart_messages .price").text()+'</span><span>' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="cart__item__info__price" style="right: 35%;"><span class="info-label">'+jQuery(".cart_messages .qty").text()+'</span><span>' + item.quantity + '</span></div></div></li>').appendTo(table);
            });
          }
          else {
            jQuery('.cart_message').show();
          }
        }
      });
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};